import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpButton のスタイル
 */
export const hotlineLpButtonStyle = tv({
    defaultVariants: {
        color: 'blue',
        size: 'medium',
    },
    slots: {
        base: [
            'text-16 font-bold',
            'inline-flex items-center justify-center',
            'rounded-full',
        ],
    },
    variants: {
        /** 色 */
        color: {
            blue: {
                base: [
                    'text-[#FFFFFF]',
                    'bg-gradient-to-r from-[#689AFD] to-[#3160D8]',
                    'hover:bg-none hover:bg-[#4881F1] active:bg-[#3160D8]',
                ],
            },
            white: {
                base: [
                    'text-[#4881F1] active:text-[#FFFFFF]',
                    'bg-[#FFFFFF]',
                    'border border-solid border-[#A6C3F2] hover:border-[#4881F1]',
                    'hover:bg-[#EDF2FF] active:bg-[#4881F1]',
                ],
            },
        },
        /** 大きさ */
        size: {
            large: {
                base: 'h-[64px] w-[320px]',
            },
            medium: {
                base: 'h-[56px] w-[300px]',
            },
            small: {
                base: 'h-[48px] w-[160px]',
            },
        },
    },
}, {
    responsiveVariants: true,
});
